"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const WolkenNodeValidation_1 = require("../validations/WolkenNodeValidation");
class WolkenNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.WOLKEN };
    if (props.type !== types_1.NODE_TYPES.WOLKEN)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        config: "",
        action: "",
        params: {}
      };
    return {
      ...nodeData,
      config: nodeData.config.substr(1)
    };
  }
  serialize(uiData) {
    return {
      ...uiData,
      config: "@" + uiData.config
    };
  }
  validate() {
    return new WolkenNodeValidation_1.WolkenNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.WolkenNode = WolkenNode;
//# sourceMappingURL=WolkenNode.js.map
